import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';

function debounce(func, timeout = 100){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

function hoverScroll(sections) {
    sections.forEach(section => {
        const teasersWrapper = $qs('[data-target="teasers-wrapper"]', section);
        const teasersContainer = $qs('[data-target="teasers-container"]', section);
        const container = $qs('.container', section);
        const moveWidth = teasersContainer.scrollWidth - window.innerWidth + ((window.innerWidth - container.clientWidth) / 2) + 28;
        const duration = 0.75;
        const easing = 'power3.inOut';
        let moved = false;
        let movedDirection = 'centre';

        function handleMouseMove(e) {
            const { clientX } = e;

            // left
            if (!moved && clientX < (window.innerWidth / 4)) {
                moved = true;
                movedDirection = 'left';

                gsap.to(teasersContainer, {
                    x: `${moveWidth}px`,
                    duration: duration,
                    ease: easing,
                });
            }

            // centre
            if (moved && movedDirection !== 'centre' && (movedDirection === 'left' && clientX > (window.innerWidth / 4)) || (movedDirection === 'right' && clientX < ((window.innerWidth / 4) * 3))) {
                gsap.to(teasersContainer, {
                    x: `0px`,
                    duration: duration,
                    ease: easing,
                    onComplete: () => {
                        moved = false;
                        movedDirection = 'centre';
                    }
                });
            }

            // right
            if (!moved && clientX > ((window.innerWidth / 4) * 3)) {
                moved = true;
                movedDirection = 'right';

                gsap.to(teasersContainer, {
                    x: `-${moveWidth}px`,
                    duration: duration,
                    ease: easing
                });
            }
        }

        function handleMouseLeave(e) {
            if (movedDirection !== 'centre') {
                gsap.to(teasersContainer, {
                    x: `0px`,
                    duration: duration,
                    ease: easing,
                    onComplete: () => {
                        moved = false;
                        movedDirection = 'centre';
                    }
                });
            }
        }

        teasersWrapper.addEventListener('mousemove', debounce((e) => handleMouseMove(e)));
        teasersWrapper.addEventListener('mouseleave', handleMouseLeave);
    });
}

function whereNext() {
    const sections = $qsa('[data-name="where-next"]');

    if (!sections) return;

    hoverScroll(sections);
}

export default whereNext;